import { Inertia } from '@inertiajs/inertia'
import { createStore } from '@stencil/store'
import Axios from 'axios'

import { CallStore } from '../../page/call/detail/state'
import { CrmTimeoutMS, getICrmStateDefaults, ICrmState, showNoContactsToast } from '../state'

declare global {
  interface LocalStorageKeys {
    closeConnectDismissed: boolean
  }
}

export type CloseioIntegrationState = typeof CloseioIntegrationStore.state
export const CloseioIntegrationStore = createStore<ICrmState>(getICrmStateDefaults())

CloseioIntegrationStore.onChange('refreshingContacts', (newValue) => {
  showNoContactsToast(CloseioIntegrationStore, 'closeio', newValue)
})

function onSyncTimeout() {
  if (CloseioIntegrationStore.state.callCurrentlySyncing) {
    CloseioIntegrationStore.state.syncTimedOut = true
    window.Sentry?.captureMessage(`Timed out syncing to Close on call ${CallStore.state.call.id}`)
    Inertia.reload({ only: ['integrations'] })
  }
}

export async function syncToCloseio(isManualSync = false) {
  if (CloseioIntegrationStore.state.connectedTo) {
    CloseioIntegrationStore.state.callCurrentlySyncing = true
    CloseioIntegrationStore.state.timeout = window.setTimeout(() => onSyncTimeout(), CrmTimeoutMS)
    await Axios.post<string[]>(CloseioIntegrationStore.state.syncUrl, {
      is_manual_sync: isManualSync,
    })
  }
}
